var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDustParticlesICon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 110,
    viewBox: "0 0 154 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.3818 108.121C98.8656 108.121 98.3474 108.095 97.8311 108.066C96.3355 107.958 95.1909 106.652 95.301 105.155C95.4092 103.659 96.7151 102.57 98.2126 102.625C102.946 102.951 107.574 101.237 110.92 97.891C114.021 94.8161 115.709 90.7069 115.709 86.3527C115.709 81.9986 114.021 77.8912 110.92 74.8164C107.817 71.7416 103.736 70.0276 99.3817 70.0276H17.7501C16.2545 70.0276 15.0283 68.8034 15.0283 67.3058C15.0283 65.8102 16.2525 64.584 17.7501 64.584H99.3817C105.205 64.584 110.673 66.8427 114.782 70.9517C118.892 75.061 121.15 80.5293 121.15 86.3524C121.15 92.1754 118.891 97.6438 114.782 101.753C110.675 105.836 105.123 108.121 99.3817 108.121L99.3818 108.121Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118.436 56.4251H4.15151C2.65586 56.4251 1.42969 55.2009 1.42969 53.7033C1.42969 52.2076 2.65391 50.9815 4.15151 50.9815H118.436C130.435 50.9815 140.205 41.2124 140.205 29.2126C140.205 17.2132 130.436 7.44366 118.436 7.44366C116.94 7.44366 115.714 6.21943 115.714 4.72183C115.714 3.22618 116.938 2 118.436 2C133.428 2 145.646 14.218 145.646 29.2105C145.646 44.2069 133.43 56.4249 118.436 56.4249V56.4251Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0978 40.0996C68.0978 42.3545 66.27 44.1804 64.0151 44.1804C61.7621 44.1804 59.9343 42.3545 59.9343 40.0996C59.9343 37.8447 61.7621 36.0188 64.0151 36.0188C66.27 36.0188 68.0978 37.8447 68.0978 40.0996Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0978 40.0996C68.0978 42.3545 66.27 44.1804 64.0151 44.1804C61.7621 44.1804 59.9343 42.3545 59.9343 40.0996C59.9343 37.8447 61.7621 36.0188 64.0151 36.0188C66.27 36.0188 68.0978 37.8447 68.0978 40.0996",
    stroke: "white",
    strokeWidth: 2.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5847 42.8215C92.5847 45.0745 90.7568 46.9023 88.5038 46.9023C86.249 46.9023 84.4211 45.0745 84.4211 42.8215C84.4211 40.5666 86.249 38.7388 88.5038 38.7388C90.7568 38.7388 92.5847 40.5666 92.5847 42.8215Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M114.348 34.6596C114.348 36.9126 112.52 38.7404 110.268 38.7404C108.013 38.7404 106.185 36.9126 106.185 34.6596C106.185 32.4047 108.013 30.5769 110.268 30.5769C112.52 30.5769 114.348 32.4047 114.348 34.6596Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2119 80.9167C57.2119 83.1716 55.386 84.9975 53.1311 84.9975C50.8762 84.9975 49.0503 83.1716 49.0503 80.9167C49.0503 78.6619 50.8762 76.8359 53.1311 76.8359C55.386 76.8359 57.2119 78.6619 57.2119 80.9167Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2587 83.6364C76.2587 85.8894 74.4309 87.7172 72.176 87.7172C69.923 87.7172 68.0952 85.8894 68.0952 83.6364C68.0952 81.3815 69.923 79.5537 72.176 79.5537C74.4309 79.5537 76.2587 81.3815 76.2587 83.6364Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M98.029 86.3599C98.029 88.6147 96.2031 90.4425 93.9482 90.4425C91.6933 90.4425 89.8674 88.6147 89.8674 86.3599C89.8674 84.1069 91.6933 82.2791 93.9482 82.2791C96.2031 82.2791 98.029 84.1069 98.029 86.3599Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M138.838 86.3599C138.838 88.6147 137.012 90.4425 134.757 90.4425C132.502 90.4425 130.676 88.6147 130.676 86.3599C130.676 84.1069 132.502 82.2791 134.757 82.2791C137.012 82.2791 138.838 84.1069 138.838 86.3599Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3661 97.2404C65.3661 99.4934 63.5383 101.321 61.2853 101.321C59.0305 101.321 57.2026 99.4934 57.2026 97.2404C57.2026 94.9855 59.0305 93.1577 61.2853 93.1577C63.5383 93.1577 65.3661 94.9855 65.3661 97.2404Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M133.393 67.3127C133.393 69.5676 131.565 71.3935 129.312 71.3935C127.058 71.3935 125.23 69.5676 125.23 67.3127C125.23 65.0579 127.058 63.2319 129.312 63.2319C131.565 63.2319 133.393 65.0579 133.393 67.3127Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M152.453 64.5886C152.453 66.8435 150.627 68.6713 148.372 68.6713C146.117 68.6713 144.292 66.8435 144.292 64.5886C144.292 62.3356 146.117 60.5078 148.372 60.5078C150.627 60.5078 152.453 62.3356 152.453 64.5886Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M100.75 21.0568C100.75 23.3098 98.9219 25.1376 96.6689 25.1376C94.414 25.1376 92.5862 23.3098 92.5862 21.0568C92.5862 18.8019 94.414 16.9741 96.6689 16.9741C98.9219 16.9741 100.75 18.8019 100.75 21.0568Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4218 29.2155C84.4218 31.4685 82.5959 33.2963 80.341 33.2963C78.0862 33.2963 76.2603 31.4685 76.2603 29.2155C76.2603 26.9606 78.0862 25.1328 80.341 25.1328C82.5959 25.1328 84.4218 26.9606 84.4218 29.2155Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDustParticlesICon);
export default __webpack_public_path__ + "static/media/dustParticlesICon.213898c08e186ab82c724ed607b6b516.svg";
export { ForwardRef as ReactComponent };